module.exports = __webpack_public_path__ + "static/media/squared.3e621e51.jpg";